import { styled } from 'next-yak';

import { spaceM, spaceXL } from '@xing-com/tokens';

export const ActionGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${spaceXL};
  gap: ${spaceM};
  align-items: center;

  & > [data-xds='Button'] {
    align-self: stretch;
  }
`;
